import commonActions from '@/store/ui/common/actions'
import { get, isEmpty, findIndex, includes } from 'lodash'

function parseXDevice(accountData, xdeviceData) {
    return accountData.xdevice_conf_id !== '0' && get(xdeviceData, 'status', '') === 'active'
}

const actions = {
    ...commonActions,

    updateStoreSetting({ commit }, params) {
        commit('setSettingName', { name: params.name })
        if (params.type === 'general') {
            commit('setGeneralSetting', { type: params.name, activate: params.activate })
        } else if (params.type === 'sociodemo') {
            commit('setSocioDemoSetting', { type: params.name, activate: params.activate })
        } else if (params.type === 'dataMining') {
            commit('setDataMiningSetting', { type: params.name, activate: params.activate })
        } else if (params.type === 'wamFactory') {
            commit('setWamFactoSetting', { type: params.name, activate: params.activate })
        }
        commit('ui/settings/setIsLoading', { isLoading: false }, { root: true })
    },
    setsUiGeneralSettings({ commit }, params) {
        commit('setGeneralSetting', { type: 'accuracy', activate: params.accountData.throttle_level === 'YES' })
        commit('setGeneralSetting', { type: 'catalog', activate: params.accountData.account_type === 'thirdparty_provider' })
        commit('setGeneralSetting', { type: 'demographicBreakdown', activate: params.accountData.demographic_breakdown_activated === 'YES' })
        commit('setGeneralSetting', { type: 'frequency', activate: params.accountData.frequency_activated === 'YES' })
        commit('setGeneralSetting', { type: 'quantile', activate: params.accountData.quantile_activated === 'YES' })
        commit('setGeneralSetting', { type: 'surfintensity', activate: params.accountData.surf_intensity_activated === 'YES' })
        commit('setGeneralSetting', { type: 'bootstrapPush', activate: params.accountData.stock_delivery_activated === 'YES' })
        commit('setGeneralSetting', { type: 'firstPartyCookie', activate: params.accountData.first_party_cookie_volume_activated === 'YES' })
        commit('setGeneralSetting', { type: 'providerFirstIdActivated', activate: params.accountData.provider_firstid_activated === 'YES' })
        commit('setGeneralSetting', { type: 'providerUtiqActivated', activate: params.accountData.provider_utiq_activated === 'YES' })
        if (!isEmpty(params.xdeviceData)) {
            commit('setGeneralSetting', { type: 'xdevice', activate: parseXDevice(params.accountData, params.xdeviceData) })
        }
    },
    setsUiSocioDemoSettings({ commit }, params) {
        commit('setSocioDemoSetting', { type: 'behavioral', activate: params.accountData.bigsea_behavioral === 'YES' })
        commit('setSocioDemoSetting', { type: 'demographic', activate: params.accountData.bigsea_sociodemo === 'YES' })
        commit('setSocioDemoSetting', { type: 'geography', activate: params.accountData.geographic_activated === 'YES' })
        commit('setSocioDemoSetting', { type: 'technology', activate: params.accountData.technologic_activated === 'YES' })
    },
    setsUiDataMiningSettings({ commit }, params) {
        commit('setDataMiningSetting', { type: 'datamining', activate: params.accountData.datamining_activation !== 'none' })
        commit('setDataMiningSetting', {
            type: 'encryption',
            activate: params.ssh_public_key === '' ? true : params.accountData.datamining_encryption === 'YES'
        })
        commit('setDataMiningSetting', { type: 'fullmode', activate: params.accountData.datamining_fullmode === 'YES' })
        commit('setDataMiningSetting', { type: 'secondparty', activate: params.accountData.datamining_2ndparty_activated === 'YES' })
        commit('setDataMiningSetting', { type: 'thirdparty', activate: params.accountData.datamining_3rdparty_activated === 'YES' })
        commit('setDataMiningSetting', { type: 'altid', activate: params.accountData.datamining_altids_activated === 'YES' })
        commit('setDataMiningSetting', { type: 'sshKey', activate: params.accountData.ssh_public_key })
    },
    setsUiWamFactoSettings({ commit }, params) {
        commit('setWamFactoSetting', { type: 'wamfactory', activate: params.accountData.wam_factory_activated === 'YES' })
        commit('setWamFactoSetting', { type: 'bootstrap', activate: params.accountData.bootstrap_custom_segment_available === 'YES' })
        commit('setWamFactoSetting', { type: 'logs', activate: params.accountData.wamfactory_logs_activated === 'YES' })
        commit('setWamFactoSetting', { type: 'estimation', activate: params.accountData.rule_estimation_activated === 'YES' })
        commit('setWamFactoSetting', { type: 'ruleVersion', activate: params.accountData.wamfactory_rules_version === 'V2' })
    },

    setActiveSharingAction({ commit, state }, params) {
        // Adding unchecked sharings and adding them to delete or add arrays for activation or deactivation
        if (!includes(state.sharing.activeSharing, params.sharingId)) {
            commit('setActiveSharing', { sharingId: params.sharingId, action: 'add' })
            if (!includes(state.sharing.sharingToAdd, params.sharingId) && params.currentStatus === 'inactive') {
                commit('setSharingToAdd', { sharingId: params.sharingId, action: 'add' })
            }
            if (includes(state.sharing.sharingToRemove, params.sharingId)) {
                commit('setSharingToRemove', { sharingId: params.sharingId, action: 'remove' })
            }
        } else {
            //Removing checked sharings
            const indexToDelete = findIndex(state.sharing.activeSharing, item => item === params.sharingId)
            commit('setActiveSharing', { sharingId: params.sharingId, action: 'remove', indexToDelete: indexToDelete })
            if (includes(state.sharing.sharingToAdd, params.sharingId)) {
                commit('setSharingToAdd', { sharingId: params.sharingId, action: 'remove' })
            }
            if (!includes(state.sharing.sharingToRemove, params.sharingId) && params.currentStatus === 'active') {
                commit('setSharingToRemove', { sharingId: params.sharingId, action: 'add' })
            }
        }
    }
}

export default actions
